import { render } from "./PortfolioHeading.vue?vue&type=template&id=3c18819e"
import script from "./PortfolioHeading.vue?vue&type=script&lang=js"
export * from "./PortfolioHeading.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__